import { USER_PERMISSIONS } from "config/constants";
import BannerListScreen from "./List";
import BannerCreateScreen from "./Create";
import BannerEditScreen from "./Edit";
import BannerDetailScreen from "./Detail";
import BannerQueueScreen from "./Queue";

const router = [
  {
    key: "marketing-banner-list",
    path: "/marketing-banner",
    component: BannerListScreen,
    exact: true,
    permissions: [USER_PERMISSIONS.PROMOTION_VIEW],
  },
  {
    key: "marketing-banner-create",
    path: "/marketing-banner/create",
    component: BannerCreateScreen,
    exact: true,
    permissions: [USER_PERMISSIONS.PROMOTION_CREATE],
  },
  {
    key: "marketing-banner-edit",
    path: "/marketing-banner/edit/:id",
    component: BannerEditScreen,
    exact: true,
    permissions: [USER_PERMISSIONS.PROMOTION_UPDATE],
  },
  {
    key: "marketing-banner-detail",
    path: "/marketing-banner/detail/:id",
    component: BannerDetailScreen,
    exact: true,
    permissions: [USER_PERMISSIONS.PROMOTION_DETAIL_VIEW],
  },
  {
    key: "marketing-banner-queue",
    path: "/marketing-banner/queue",
    component: BannerQueueScreen,
    exact: true,
    permissions: [USER_PERMISSIONS.PROMOTION_UPDATE],
  },
];

export default router;
